import Vue from 'vue'
import VueRouter from 'vue-router'

import ProjectsTabs from '@/views/ProjectsTabs.vue'
import LoginAndCenters from '@/views/LoginAndCenters.vue'
import store from '../store'
// import $eventBus from '../helpers/eventBus'

Vue.use(VueRouter)

const routes = [
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    name: 'projects-tabs',
    path: '/',
    component: ProjectsTabs
  },
  {
    name: 'login',
    path: '/login',
    component: LoginAndCenters
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let firstEnter = true
router.beforeEach(async (to, from, next) => {
	// first time
	if (firstEnter) {
		firstEnter = false
		const user = JSON.parse(localStorage.getItem('auth'))
		if (user) {
			await store
				.dispatch('auth/login', {
					userName: user?.userName,
					password: user?.password,
					centerId: user?.centerId
				})
				.finally(() => {
					// $eventBus.$emit('loader', false)
				})
		} else if (to.name !== 'login') {
			next({ name: 'login' })
			return
		}
	}

	// the page in public
	if (!to.meta.permissionTab) {
		next()
		return
	}

	const permission = store.state.auth.permissions

	let allowed = true
	to.meta.permissionTab.forEach((e) => {
		allowed &= permission[e]
	})
	if (allowed) {
		next()
	}
})

export default router
